import { BoxV2 as Box, Flex, ExpandableText, Grid } from 'portal-commons';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { TableCell, TableRow } from '@material-ui/core';

import { CroppableItem } from '@/components';
import { getEventTypeImage } from '@/constants';
import { createCampaignRedirectorPath } from '@/utils/path';
import { humanizeAuthenticatedUser } from '@/utils/string';

function EventsListingRow(props) {
  const { event } = props;
  const authenticatedUser = humanizeAuthenticatedUser(event.authenticatedUser);
  return (
    <TableRow
      onClick={(e) => {
        event.campaignUid
          ? props.history.push({
              pathname: `/campaigns/${event.campaignUid}`,
              state: {
                goBackPage: `${props.location.pathname}${
                  props.location.search ? props.location.search : ''
                }`,
              },
            })
          : e.preventDefault();
      }}
      className={event.campaignUid ? 'link' : ''}
      data-testid="eventsListingRow"
    >
      <TableCell
        style={{
          fontWeight: 500,
        }}
        align="left"
        data-testid="eventsListingRowEventTypeDescription"
      >
        <Flex sx={{ alignItems: 'center' }}>
          <Box sx={{ mr: 's' }}>{getEventTypeImage(event.eventType)}</Box>
          {event.eventType || '--'}
        </Flex>
      </TableCell>
      <TableCell align="left" data-testid="eventsListingRowCategoryType">
        {event.categoryType}
      </TableCell>
      <TableCell
        align="left"
        className={`${event.campaignUid ? 'events-listing-table-link' : ''}`}
        data-testid="eventsListingRowCampaignUid"
        onClick={(e) => {
          e.stopPropagation();
          if (event.campaignUid) {
            props.history.push({
              pathname: createCampaignRedirectorPath(event.campaignUid),
              state: {
                goBackPage: `${props.location.pathname}${
                  props.location.search ? props.location.search : ''
                }`,
              },
            });
          }
        }}
      >
        {event.campaignUid}
      </TableCell>
      <TableCell
        align="left"
        className={`${event.brandUid ? 'events-listing-table-link' : ''}`}
        data-testid="eventsListingRowBrandUid"
        onClick={(e) => {
          e.stopPropagation();
          if (event.brandUid) {
            props.history.push({
              pathname: `/brands/${event.brandUid}`,
              state: {
                goBackPage: `${props.location.pathname}${
                  props.location.search ? props.location.search : ''
                }`,
              },
            });
          }
        }}
      >
        {event.brandUid}
      </TableCell>
      <TableCell
        style={{ maxWidth: 160 }}
        data-testid="eventsListingRowCreateDate"
      >
        <CroppableItem title={event.createDate}>
          {event.createDate}
        </CroppableItem>
      </TableCell>
      <TableCell
        style={{ maxWidth: 120 }}
        data-testid="eventsListingRowAuthenticatedUser"
      >
        <CroppableItem title={authenticatedUser}>
          {authenticatedUser}
        </CroppableItem>
      </TableCell>
      <TableCell
        align="left"
        onClick={(e) => e.stopPropagation()}
        data-testid="eventsListingRowDescription"
      >
        <Grid
          sx={{
            gridTemplateColumns: 'minmax(200px, 1fr)',
            width: '100%',
          }}
        >
          <ExpandableText text={event.description} maxWidth="100%" />
        </Grid>
      </TableCell>
    </TableRow>
  );
}
export default withRouter(EventsListingRow);
